module.exports = __webpack_public_path__ + "img/fuwudingdan001.c59955a6.png";